import { ReviewKind, ReviewOutcome } from "../utils/reviewModel";

export const kindLabels: Record<ReviewKind, string> = {
    created: "New",
    updated: "Edited",
    deleted: "Deleted",
    moved: "Moved",
    files: "Files",
};

export const outcomeLabels: Record<ReviewOutcome, string> = {
    applied: "Applied",
    failed: "Failed",
    skipped: "Not applied",
};

/** A small dot in the kind's colour (tree rows, summary tags); the kind is its accessible name. */
export function ReviewKindDot(props: { kind: ReviewKind }) {
    return <span className={`review-kind-dot kind-${props.kind}`} role="img" aria-label={kindLabels[props.kind]} title={kindLabels[props.kind]} />;
}

/** The kind as a tag (`New`, `Edited`…), as the page header shows tags. */
export function ReviewKindTag(props: { kind: ReviewKind }) {
    return <span className={`review-tag review-kind-tag kind-${props.kind}`}>{kindLabels[props.kind]}</span>;
}
